import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgInfoCircled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M8.03125 7C7.86549 7 7.70652 7.06585 7.58931 7.18306C7.4721 7.30027 7.40625 7.45924 7.40625 7.625V11.375C7.40625 11.5408 7.4721 11.6997 7.58931 11.8169C7.70652 11.9342 7.86549 12 8.03125 12C8.19701 12 8.35598 11.9342 8.47319 11.8169C8.5904 11.6997 8.65625 11.5408 8.65625 11.375V7.625C8.65625 7.45924 8.5904 7.30027 8.47319 7.18306C8.35598 7.06585 8.19701 7 8.03125 7ZM8.03125 4.5C7.87673 4.5 7.72569 4.54582 7.59721 4.63166C7.46874 4.71751 7.3686 4.83952 7.30947 4.98228C7.25034 5.12503 7.23487 5.28212 7.26501 5.43366C7.29516 5.58521 7.36956 5.72442 7.47882 5.83368C7.58808 5.94294 7.72729 6.01734 7.87884 6.04749C8.03038 6.07763 8.18747 6.06216 8.33022 6.00303C8.47298 5.9439 8.59499 5.84377 8.68084 5.71529C8.76668 5.58681 8.8125 5.43577 8.8125 5.28125C8.8125 5.07405 8.73019 4.87534 8.58368 4.72882C8.43716 4.58231 8.23845 4.5 8.03125 4.5Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.065 13.88C11.2765 13.88 13.88 11.2765 13.88 8.065C13.88 4.85346 11.2765 2.25 8.065 2.25C4.85346 2.25 2.25 4.85346 2.25 8.065C2.25 11.2765 4.85346 13.88 8.065 13.88ZM8.065 15.13C11.9669 15.13 15.13 11.9669 15.13 8.065C15.13 4.16311 11.9669 1 8.065 1C4.16311 1 1 4.16311 1 8.065C1 11.9669 4.16311 15.13 8.065 15.13Z"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgInfoCircled)
const IconSvgInfoCircled = createIcon(ForwardRef, 'SvgInfoCircled')
export default IconSvgInfoCircled
